import React from "react";
import { Button, Col, Form, Row, Skeleton } from "antd";
import { useState } from "react";
import OptionalItem from "../optional-item/OptionalItem";
import { useEffect } from "react";
import { Title } from "@frontend/components/atoms/Title";
import "./OptionalsList.scss";

// Refacfor de portales: Eliminar este archivo Y sus dependencias de profile_settings
const OptionalsListForm = ({ optionals = [], onSaveData, isFetching, form }) => {
  const [optionalsToUpdate, setOptionalsToUpdate] = useState([]);
  const { getFieldDecorator} = form
  useEffect(() => {
    setOptionalsToUpdate(optionals);
  }, [optionals]);

  const onChangeItem = (value, itemId) => {
    setOptionalsToUpdate(
      optionalsToUpdate.map((item) =>
        item.id === itemId && value !== item.available
          ? { ...{ id: itemId, available: value } }
          : item
      )
    );
  };

  console.log("optionalsToUpdate",optionalsToUpdate);
  if (isFetching) {
    return (
      <Skeleton
        title={true}
        active={true}
        paragraph={{
          rows: 6,
        }}
      />
    );
  }

  return (
    <div>
      { optionals.length > 0 && 
        <Form
        className="OptionalsList"
        onSubmit={(e) => onSaveData(optionalsToUpdate, e)}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="OptionalsList-items">
          {optionals.map((optional, key) => {
            return (
                <Col xs={24} sm={24} md={12} key={key}>
                  <OptionalItem
                    optional={optional}
                    key={key}
                    onChangeItem={(value) => onChangeItem(value, optional.id)}
                  />
                </Col>
            );
          })}
          </Row>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ float: "right" }}
            >
              Guardar
            </Button>
          </Form.Item>
        </Form>
      }
      {!isFetching && optionals.length == 0 &&
        <Title level={5}>No hay opciones disponibles.</Title>
      }
    </div>
  );
};

const createForm = typeof window === "undefined"
  ? () => () => null
  : Form.create;

const OptionalsList = createForm({name: "optionals_list"})(OptionalsListForm)

export default OptionalsList;
